import { Typography } from '@material-ui/core';
import styled from '~/styles';

export const Title = styled(Typography)`
  color: ${(p) => p.theme.palette.primary.main};
  font-size: 22px;
`;
